"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const CopyrightPanel_1 = __importDefault(require("./components/CopyrightPanel"));
const ColumnPanel_1 = __importDefault(require("./components/ColumnPanel"));
const useBreakpoints_1 = require("../utils/useBreakpoints");
const Container_1 = __importDefault(require("../common/Container/Container"));
const Footer_styles_1 = __importDefault(require("./Footer.styles"));
const Footer = ({ footerCopyright, footerColumn, sx = {}, }) => {
    const breakpoints = (0, useBreakpoints_1.useBreakpoints)(['mdDown', 'mdUp']);
    const copyrightPanel = (react_1.default.createElement(CopyrightPanel_1.default, { logoUrl: footerCopyright.logoUrl, label: footerCopyright.label, copyrightText: footerCopyright.copyrightText, logoAlt: footerCopyright.logoAlt }));
    return (react_1.default.createElement(Box_1.default, { sx: Object.assign(Object.assign({}, Footer_styles_1.default.background), sx) },
        react_1.default.createElement(Container_1.default, null,
            react_1.default.createElement(Box_1.default, { sx: Footer_styles_1.default.navigation },
                breakpoints.mdUp && copyrightPanel,
                footerColumn.map((item) => (react_1.default.createElement(ColumnPanel_1.default, { key: item.label, label: item.label, links: item.links })))),
            breakpoints.mdDown && copyrightPanel)));
};
exports.default = Footer;
